import React, { memo } from "react";
import PropTypes from "prop-types";

import { ColumnFooter } from "../columfooter";

import styles from "../../datasheet.css";

function DataSheetFooterComponent(props) {
  const {
    totalWidth,
    tableGridTemplate,
    fixedColumnWidth,
    fixedColumnGridTemplate,
    fixedColumns,
    nonFixedColumns,
    canAddColumn,
    footers = {},
    previewOption
  } = props;
  return (
    <div
      className={styles.footer}
      style={{
        gridTemplateColumns: tableGridTemplate,
        width: `${totalWidth}px`
      }}
    >
      <div
        className={styles.leftFixed}
        style={{
          gridTemplateColumns: fixedColumnGridTemplate,
          width: `${fixedColumnWidth}px`
        }}
      >
        <div style={{ backgroundColor: "var(--bg-gray)" }} />
        {previewOption && <ColumnFooter />}

        {fixedColumns.map((column, i) => {
          return (
            <ColumnFooter
              column={column}
              key={column && column.id}
              footer={footers[column.id]}
            />
          );
        })}
      </div>
      {nonFixedColumns.map((column, i) => {
        return (
          <ColumnFooter
            column={column}
            key={column && column.id}
            footer={footers[column.id]}
          />
        );
      })}
      {canAddColumn && <div className={styles.rightFixed} />}
      {/* <div className={styles.emptyspace} /> */}
    </div>
  );
}

DataSheetFooterComponent.propTypes = {
  totalWidth: PropTypes.number,
  tableGridTemplate: PropTypes.string,
  fixedColumnWidth: PropTypes.number,
  fixedColumnGridTemplate: PropTypes.string,
  fixedColumns: PropTypes.array,
  nonFixedColumns: PropTypes.array,
  canAddColumn: PropTypes.bool,
  footers: PropTypes.any,
  previewOption: PropTypes.bool
};

export const DataSheetFooter = memo(DataSheetFooterComponent);
